import { getChartIcon } from 'components/metric/chart';
import { svgElementFromString } from 'components/metric/chart/svgTools';
import { Theme } from '@mui/material';
import { IKpiAlertEventFilters, parseDate } from '@report-content';
import { Highcharts } from 'components/chart/Chart';
import { IKpiAlertEvent } from '@report-content';
import { SeriesAlertId, SeriesPrimaryId } from './index';
import { PointOptionsObject } from 'highcharts';

type AlertNewsType = 'good' | 'bad' | 'neutral';

export interface IKpiAlertPointData {
    isFlagSeries: boolean;
    measurementTime: string;
}
export function getKpiAlert(
    alertsData: IKpiAlertEvent[],
    mainSeries: Highcharts.SeriesLineOptions,
    xAxis: string,
    theme: Theme,
): Highcharts.SeriesFlagsOptions {
    const data: Array<PointOptionsObject> = [];
    const getIcon = (newsType: AlertNewsType): string => {
        let icon = getChartIcon('alertNChartIcon', theme);
        switch (newsType) {
            case 'good':
                icon = getChartIcon('alertGChartIcon', theme);
                break;
            case 'bad':
                icon = getChartIcon('alertBChartIcon', theme);
        }
        // Highcharts 11 keeps flag hover listeners only on the SVG label box under this image,
        // so the image must let pointer events through or the tooltip never opens.
        return `<img src="${svgElementFromString(icon, true)}"
                              style="width:20px; height:20px; left:-9px; top:-5px; position:absolute; z-index:1; pointer-events:none" />`;
    };

    const mainPoints = (mainSeries?.data ?? []) as PointOptionsObject[];
    const latestPoint = mainPoints.reduce<PointOptionsObject | undefined>(
        (latest, p) => (latest === undefined || (p.x as number) > (latest.x as number) ? p : latest),
        undefined,
    );

    const processAlertEvent = (title: string, filters: IKpiAlertEventFilters) => {
        // A result row without the x-axis column is a whole-instance total, so it describes the current value
        const point = filters[xAxis]
            ? mainPoints.find((p) => p.x == parseDate(filters[xAxis] as string).getTime())
            : latestPoint;
        if (point) {
            data.push({
                x: point.x,
                title: getIcon('bad'),
                text: title,
                custom: {
                    measurementTime: filters[xAxis],
                    isFlagSeries: true,
                } as IKpiAlertPointData,
            });
        }
    };

    alertsData.forEach((alert) => {
        if (xAxis == 'measurement_time') {
            processAlertEvent(alert.title, { ...alert.filters, measurement_time: alert.measurement_time });
        } else {
            alert.result_data.forEach((alertEvent) => {
                processAlertEvent(alertEvent.title, alertEvent.row);
            });
        }
    });
    return {
        type: 'flags',
        name: 'Alert Events',
        onSeries: SeriesPrimaryId,
        // Hiding/showing the primary series via the legend also hides/shows this one - there's
        // no point leaving alert flags floating over an axis with no line to anchor them to.
        linkedTo: SeriesPrimaryId,
        id: SeriesAlertId,
        //@ts-ignore
        shape: 'square',
        data: data,
        useHTML: true,
        width: 16,
        height: 16,
        y: -32,
        fillColor: 'transparent',
        stackDistance: 24,
        lineWidth: 0,
        showInLegend: false,
        states: {
            hover: {
                fillColor: 'transparent',
            },
            inactive: {
                opacity: 1,
            },
        },
        stickyTracking: false,
        visible: true,
    };
}
